"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = setMetadata;

function setMetadata(title, description) {
  document.title = title;
  document.querySelector('meta[property="og:title"]').setAttribute('content', title);
  document.querySelector('meta[name="description"]').setAttribute('content', description);
  document.querySelector('meta[property="og:description"]').setAttribute('content', description);
}


//////////////////
// WEBPACK FOOTER
// ./client/lib/metadata/index.js
// module id = 182
// module chunks = 0